import {
    convertLocalDateDTOToDate,
    convertLocalDateToString,
    areLocalDatesEqual
} from '../../../utils/dateUtil';
import { Message } from '@flos/react-ui';
import type { LocalDateDTO } from 'gw-edge-client/dist/types/dto/pc/edge/time/';
import type {
    CoverageDTO,
    CoverableDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';

const displayCoverageWarning = (
    cancellationDate: LocalDateDTO,
    coverable: CoverableDTO,
    coverage: CoverageDTO
): boolean => {
    if (!cancellationDate) return false;
    if (!coverage.publicID || !coverage.name || !coverage.effectiveDate) return false;
    if (areLocalDatesEqual(coverage.effectiveDate, coverable.effectiveDate)) return false;
    return (
        convertLocalDateDTOToDate(cancellationDate, false) <
        convertLocalDateDTOToDate(coverage.effectiveDate, false)
    );
};
export const EDICancellationCoveragesLaterInForce = ({
    coverable,
    cancellationDate
}: {
    coverable: CoverableDTO;
    cancellationDate?: LocalDateDTO;
}): React.JSX.Element => {
    const { coverages } = coverable;
    if (!coverages || !cancellationDate) return <></>;

    return (
        <>
            {coverages &&
                coverages.length > 0 &&
                coverages.map((coverage: CoverageDTO) => {
                    const { publicID, name, effectiveDate } = coverage;
                    return (
                        displayCoverageWarning(cancellationDate, coverable, coverage) && (
                            <div key={publicID}>
                                <Message
                                    id={`coverage-later-in-force-${publicID ?? ''}`}
                                    className="coverage-warning paragraph--small u-spacing-stack-s"
                                    theme="warning"
                                    title={`Vær opmærksom på at dækningen ”${String(
                                        name
                                    )}” først gælder fra ${
                                        (effectiveDate &&
                                            convertLocalDateToString(
                                                convertLocalDateDTOToDate(effectiveDate)
                                            )) ??
                                        ''
                                    }.`}
                                />
                            </div>
                        )
                    );
                })}
        </>
    );
};
